<button 
  [matMenuTriggerFor]="beforeMenu"
  class="button"
  [ngClass]="{'button--light': mode === 'light','button--dark': mode === 'dark'}"
  [class.opened]="t.menuOpen"
  #t="matMenuTrigger"
  type="ghost"
  size="md">
  <mat-icon>public</mat-icon>
  {{ translationPrefix | translate:_transParam }}
</button>

<mat-menu #beforeMenu="matMenu" xPosition="before" yPosition="below" class="menu">
  <button mat-menu-item [disableRipple]="true" class="item" *ngFor="let lang of languages; let i = index" (click)="change(lang.value)"><span class="lang">{{'topbar.' + lang.label | translate:_transParam }}</span> <span class="shortLang">{{lang.shortLabel}}</span></button>
</mat-menu>

